export const safeParseJson = (jsonString: string | undefined, defaultValue: string = '{}'): string => {
  if (!jsonString || jsonString.trim() === '') {
    return defaultValue;
  }

  try {
    const parsed = JSON.parse(jsonString);
    return JSON.stringify(parsed);
  } catch (error) {
    console.warn('Invalid JSON in task kwargs, using default:', error);
    return defaultValue;
  }
};
